import {Survey} from "src/models/survey";
import React, {forwardRef, memo, useState} from "react";
import QuestionContent from "./question-content";

interface SurveyProps {
  item:Survey,
  onFinish: () => void;
}

const SurveyWrapper =  forwardRef<HTMLDivElement,SurveyProps>(
    function ({item,onFinish},ref) {
        const [questionIdx,setQuestionIdx] = useState(0);
        const questionLen = item.questionList.length;
        function nextQuestion() {
            if ((questionIdx + 1) >= questionLen) {
                onFinish();
            } else {
                setQuestionIdx((pre) => pre + 1);
            }
        }
        return  (
            <QuestionContent ref={ref} onNext={nextQuestion} questionIdx={questionIdx} survey={item} key={
                item.questionList[questionIdx]?.questionId
            }
            />
        );
    });

export default memo((SurveyWrapper));
